import { createTracker } from 'usage-tracker';
import { isFunction } from 'sales-enablement-lib/components/feedback/internal/typeUtils';
export const trackingClient = createTracker({
  standalone: true,
  onError: error => console.error(error)
});
export const trackFeedbackCopyInteraction = (eventNamespace, action, screen = '') => {
  trackingClient.track(eventNamespace, 'Feedback Copy Buttons Interaction', {
    action,
    screen
  });
};

// TODO: Remove when all tracking events have been migrated to Standalone Tracking
export const trackInteraction = (action, screen = '', usageTracker) => {
  if (usageTracker && isFunction(usageTracker.track)) {
    usageTracker.track('feedbackCopyButtonsInteraction', {
      action,
      screen
    });
  }
};
export const trackRefreshInteraction = eventNamespace => {
  trackingClient.track(eventNamespace, 'Recent Activity Card Interaction', {
    action: 'click-refresh-icon'
  });
};